import { useMemo } from 'react';

import usePublishedVideoResources from 'services/general/videoResourcesList';
import useSubscriptions from 'services/general/subscriptionsList';
import { usePortalConfigs } from 'hooks/usePortalConfigs';

import {
  gateVideoResources,
  shouldHideTinyPlusContent,
} from '../VideoResources/VideoResources.helpers';

// Video resources after member/partner gating. Shared by the Resources page
// (filter-pill availability, result counts) and the webinars section itself.
// `hideTinyPlusContent` tells the page to also drop the Tiny+ filter pill.
export const useVisibleVideoResources = () => {
  const { data: videoResources } = usePublishedVideoResources();
  const { config, isLoading: isPortalConfigLoading } = usePortalConfigs();
  const { isAnyTinyPlus } = useSubscriptions();

  const hideTinyPlusContent = shouldHideTinyPlusContent({
    hideUpsells: config.hide_upsells,
    isAnyTinyPlus,
  });

  // Until the portal config has resolved we can't tell whether exclusive
  // content is allowed, so report "still loading" instead of flashing it.
  const visibleResources = useMemo(
    () =>
      isPortalConfigLoading
        ? undefined
        : gateVideoResources(videoResources, {
            hideUpsells: config.hide_upsells,
            isAnyTinyPlus,
          }),
    [videoResources, isPortalConfigLoading, config.hide_upsells, isAnyTinyPlus],
  );

  return { visibleResources, isAnyTinyPlus, hideTinyPlusContent };
};
